import { useEffect, useState } from 'react';

/**
 * Custom hook to debounce a value for a specified delay.
 * This is useful for optimizing performance by reducing the number of updates
 * that occur in response to rapid changes, such as user input.
 */
export function useDebounce<T>(value: T, delay: number): T {
  const [debouncedValue, setDebouncedValue] = useState<T>(value);

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedValue(value);
    }, delay);

    return () => {
      clearTimeout(handler);
    };
  }, [value, delay]);

  return debouncedValue;
}
